import { WithID } from '../../../functions/firebase/rxfireExtensions';
import {
  deferredValid,
  optional,
  required,
  useValidateFormData,
} from '../../../functions/ux/form/useForm';
import { StoreFront } from '../../../models/ClientModels';
import { validNumber } from '../../../utils/validation';

export const useIsShippingOptionsValid = (store: WithID<StoreFront>) => {
  const validate = useValidateFormData<{
    method: 'shippo' | 'custom';
    fee?: number;
  }>({
    method: { valid: required },
    fee: {
      valid: deferredValid(({ method }) =>
        method === 'shippo' ? optional : validNumber,
      ),
    },
  });
  return validate(
    store?.shippingFee != null
      ? { method: 'custom', fee: store?.shippingFee }
      : { method: 'shippo', fee: undefined },
  )[0];
};
